import { Fragment } from 'react';
import { CSSTransition } from 'react-transition-group';
import { ModalContent } from '~/components/collections';
import { rage, useObservable } from '~/rage';
import { IModalStateInvite, ModalSurface, ModalType } from '~/shared';
import { ModalInvite } from '../ModalInvite';
import { StyledModalWrapper } from './Modal.styled';

const Modal: React.FC = () => {
	const modalState = useObservable(rage.modal.getCurrentModal());

	const isInvite = modalState?.type === ModalType.Invite;
	const isOnTablet = modalState?.surface === ModalSurface.Tablet;
	const isVisibleOnScreen = !!modalState && !isInvite && !isOnTablet;
	const isInviteVisible = !!modalState && isInvite;

	return (
		<div>
			<CSSTransition
				timeout={300}
				classNames={'modal'}
				in={isVisibleOnScreen}
				unmountOnExit
			>
				<StyledModalWrapper>
					{!!modalState && <ModalContent state={modalState} />}
				</StyledModalWrapper>
			</CSSTransition>
			<CSSTransition
				timeout={300}
				classNames={'modal'}
				in={isInviteVisible}
				unmountOnExit
			>
				<Fragment>
					<ModalInvite state={modalState as IModalStateInvite} />
				</Fragment>
			</CSSTransition>
		</div>
	);
};

export { Modal };
